import { Checkbox, CheckboxProps, FormControlLabel } from "@mui/material";
import { Control, Controller, FieldValues, Path, PathValue, useFormContext } from "react-hook-form";

type FormCheckboxProps<IFormValues extends FieldValues = FieldValues> = Omit<CheckboxProps, 'name' | 'checked' | 'defaultValue'> & {
    name: Path<IFormValues>,
    control?: Control<IFormValues, any>,
    shouldUnregister?: boolean,
    defaultValue?: PathValue<IFormValues, Path<IFormValues>>,
    label: React.ReactNode
}

const FormCheckbox = <IFormValues extends FieldValues = FieldValues>({
    name,
    control,
    shouldUnregister,
    defaultValue,
    label,
    sx,
    ...props
}: FormCheckboxProps<IFormValues>) => {

    const formContext = useFormContext<IFormValues>();

    return (
        <Controller
            name={name}
            control={control ?? formContext.control}
            shouldUnregister={shouldUnregister}
            defaultValue={defaultValue}
            render={({ field, fieldState, formState }) =>
                <FormControlLabel
                    label={label}
                    sx={sx}
                    control={
                        <Checkbox
                            {...props}
                            checked={field.value}
                            onChange={(e, checked) => {
                                (!props.readOnly) && field.onChange(checked);
                                (!props.readOnly) && props.onChange?.(e, checked);
                            }}
                            onBlur={(e) => {
                                field.onBlur();
                                props.onBlur?.(e);
                            }}
                            disabled={props.disabled ?? formState.isSubmitting}
                        />
                    }
                />
            }
        />
    );
};

export default FormCheckbox;